<template>
  <v-dialog scrollable v-model="config.status.active" max-width="800px">
    <v-card class="dialog">
      <v-card-title class="primary pa-0">
        <v-toolbar flat class="amber blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">料金</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" v-if="!isImporting">
                <v-text-field required counter
                  v-model="form.handling"
                  label="手配料"
                  maxlength="10"
                />
              </v-col>
              <v-col cols="12" v-if="!isImporting">
                <v-text-field required counter
                  v-model="form.pickup"
                  label="送迎"
                  maxlength="10"
                />
              </v-col>
              <v-col cols="12" v-if="!isImporting">
                <v-text-field required counter
                  v-model="form.orientation"
                  label="オリエン"
                  maxlength="10"
                />
              </v-col>
              <v-col cols="12" v-if="!isImporting">
                <v-text-field required counter
                  v-model="form.gross"
                  label="グロス家賃"
                  maxlength="10"
                />
              </v-col>
              <v-col cols="12" v-if="!isImporting">
                <v-text-field required counter
                  v-model="form.net"
                  label="ネット家賃"
                  maxlength="10"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed v-if="isAuthed" color="secondary white--text" @click.stop="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorStaysModalsFee',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          importing: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        clientId: '',
        date: '',
        handling: '',
        pickup: '',
        orientation: '',
        gross: '',
        net: ''
      },
      store: {
      },
      rules: {
        date: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'fee',
            form: {
              content: this.form.date,
              option: {
                handling: this.form.handling,
                pickup: this.form.pickup,
                orientation: this.form.orientation,
                gross: this.form.gross,
                net: this.form.net
              }
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'charge',
                value: {
                  date: this.form.date,
                  handling: this.form.handling,
                  pickup: this.form.pickup,
                  orientation: this.form.orientation,
                  gross: this.form.gross,
                  net: this.form.net
                }
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      const { id, cid, clientId, authed, date, handling, pickup, orientation, gross, net } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        cid: cid,
        clientId: clientId,
        authed: authed,
        date: date,
        handling: handling,
        pickup: pickup,
        orientation: orientation,
        gross: gross,
        net: net
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.form.authed
    },
    isImporting () {
      return this.config.status.importing
    },
    isSetMediaId () {
      return this.store.lib.media
    },
    printFormDate () {
      return (this.form.date) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    }
  }
}
</script>
